<template>
  <div :class="props.customClass">
    <label
    :for="props.fieldName"
    v-html="props.fieldLabel"
    style="display: none;"
    ></label>
    <textarea
    :id="props.fieldName"
    :name="props.fieldName"
    v-model="fieldValue"
    @input="updateValue"
    @change="updateValue" 
    @keydown="updateValue"
    @blur="touch"
    aria-required
    :aria-labelledby="`${props.fieldName} ${props.fieldName}Errors`"
    :aria-invalid="!isValid"
    autocomplete="off">
    </textarea>
    <div
    :id="`${props.fieldName}Errors`"
    aria-live="polite"
    aria-relevant="additions removals">
      <div
      v-if="error"
      v-html="error"
      class="builderinput-error">
        
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps([
  'key',
  'fieldLabel',
  'fieldName',
  'fieldType',
  'displayType',
  'selected',
  'scope',
  'initValue',
  'required',
  'customClass',
  'initTouched',
])

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const emit = defineEmits(['updateValue'])

const fieldValue = ref(props.initValue);
const error = ref('');
let isTouched = false;
let isGood = false;
let errorText = '';
let nonStandard = false;

const isValid = computed(() => {
  if (error.value.length) return false;
  return true;
})

function updateValue() {
    
  // format value
  let stringValue = fieldValue.value;
  let saveValue = fieldValue.value;
  
  // if init touched
  if (typeof props.initTouched !== 'undefined' && props.initTouched) isTouched = true;
  
  if (isTouched) {
    error.value = errorText;
  }
  
  emit('updateValue', props.fieldName, fieldValue.value);
  if (isTouched) {
    builder.validateCurrentItem();
  }
    
    
  if (builder.isTouched) builder.validateCurrentItem();
  // e.preventDefault();
  // return false;
}

function touch(e) {
  isTouched = true;
  updateValue();
}

</script>